module.exports = __webpack_public_path__ + "img/logo.017b40d9.png";